import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import DynamicOnlineIntake from './dynamiconlineintake/App.vue'

import axios from 'axios'


import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueSignaturePad from 'vue-signature-pad';
import VueTheMask from 'vue-the-mask'
import Multiselect from 'vue-multiselect';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import {
  required,
  email,
} from 'vee-validate/dist/rules'
// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import VueI18n from 'vue-i18n'




Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.prototype.$http = axios


// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(VueSignaturePad);
Vue.use(VueTheMask);
Vue.use(VueI18n);
Vue.component('VueMultiselect', Multiselect  );

extend('required', {
  ...required,
  
  message:'This field is required'
});

extend('email', {
  ...email,
  message: 'This field must be a valid email'
});

extend('mmyyyy', {
  validate: value => {
    // Matches 01/2026 through 12/2035, etc.
    const regex = /^(0[1-9]|1[0-2])\/\d{4}$/;
    return regex.test(value);
  },
  message: 'The field must be a valid MM/YYYY format'
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);


export const i18n = new VueI18n({
  locale: 'en-English', // set locale
  fallbackLocale: 'en-English',
});

const routes = [
    { path: '/', component: App,meta:{title:'Index'} },
    { path: '/online-intake/:orgName/:subOrgName', component: DynamicOnlineIntake,meta:{title:'Online Intake'} },
   
]
const router = new VueRouter({
    mode: 'history',
    routes // short for `routes: routes`
})
router.beforeEach((to,from,next)=>{
    document.title=to.meta?.title;
 
    next();
});

const app = new Vue({
    router,
    render: h => h(App),
    i18n,
}).$mount('#app')

